import { useMemo, useState } from 'react';
import type { DrawingStartedDto } from '@shared/types';
import { Wheel } from '@shared/Wheel';
import { MAX_LABELLED_SEGMENTS } from '@shared/wheel';
import { titleCase } from '@shared/format';

export function SpinScreen({ started, receivedAtMs, onSpinStart, onSpinEnd }: {
  started: DrawingStartedDto; receivedAtMs: number; onSpinStart: () => void; onSpinEnd: () => void;
}) {
  const d = started.drawing;
  const names = useMemo(() => [...d.entrants].sort((a, b) => a.index - b.index).map((e) => e.displayName), [d.entrants]);
  const [pointer, setPointer] = useState('');
  const [remaining, setRemaining] = useState(d.spinSeconds);
  const [done, setDone] = useState(false);
  const spin = useMemo(() => ({
    winnerIndex: started.winnerIndex, landingJitter: started.landingJitter, startedAtUtc: started.startedAtUtc,
    serverNowUtc: started.serverNowUtc, spinSeconds: d.spinSeconds, receivedAtMs,
  }), [started, d.spinSeconds, receivedAtMs]);

  return (
    <div className="screen screen-spin">
      <div className="spin-top">
        <img src="./brand/kes-logo-reversed.png" alt="Keystone Energy Services" className="spin-logo" />
        <span className="spin-divider" />
        <h2>{titleCase(d.drawingType)} Drawing</h2>
      </div>
      <div className="spin-wheel">
        <Wheel names={names} spin={spin} logoSrc="./brand/kes-logo-transparent.png" size={1000}
          onSpinStart={onSpinStart} onSpinEnd={() => { setDone(true); onSpinEnd(); }} onPointerName={setPointer} onRemaining={setRemaining} />
      </div>
      <div className="spin-bottom">
        {names.length > MAX_LABELLED_SEGMENTS && <div className="pointer-name">{pointer}</div>}
        <div className="spin-meta tabular">
          {done ? 'And the winner is…' : `${remaining.toFixed(1)}s`} <span>•</span> {d.entrantCount} entrants <span>•</span> {d.prizeName}
        </div>
      </div>
    </div>
  );
}
